"use strict";
// (C) 2021-2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.setExecutionResultData = exports.setExecutionResultError = exports.setExecutionResultLoading = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var isString_1 = tslib_1.__importDefault(require("lodash/isString"));
function upsertExecutionResult(id, envelopeData, correlationId) {
    return {
        type: "GDC.DASH/CMD.EXECUTION_RESULT.UPSERT",
        correlationId: correlationId,
        payload: tslib_1.__assign(tslib_1.__assign({}, envelopeData), { id: isString_1.default(id) ? id : sdk_model_1.serializeObjRef(id) }),
    };
}
/**
 * Creates an {@link UpsertExecutionResult} command that makes the relevant execution result indicate it is loading.
 *
 * @beta
 */
function setExecutionResultLoading(id, correlationId) {
    return upsertExecutionResult(id, {
        isLoading: true,
        executionResult: undefined,
        error: undefined,
        warnings: undefined,
    }, correlationId);
}
exports.setExecutionResultLoading = setExecutionResultLoading;
/**
 * Creates an {@link UpsertExecutionResult} command that makes the relevant execution result indicate an error and stop loading.
 *
 * @beta
 */
function setExecutionResultError(id, error, correlationId) {
    return upsertExecutionResult(id, {
        isLoading: false,
        error: error,
        executionResult: undefined,
        warnings: undefined,
    }, correlationId);
}
exports.setExecutionResultError = setExecutionResultError;
/**
 * Creates an {@link UpsertExecutionResult} command that makes the relevant execution result set new result data and stop loading.
 *
 * @beta
 */
function setExecutionResultData(id, executionResult, executionWarnings, correlationId) {
    return upsertExecutionResult(id, {
        isLoading: false,
        error: undefined,
        executionResult: executionResult,
        warnings: executionWarnings,
    }, correlationId);
}
exports.setExecutionResultData = setExecutionResultData;
//# sourceMappingURL=executionResults.js.map